import type { ThemeQueryFilters } from "../../common/types/DynamicTheme";
import {
    type ParsedThemeUrlState,
    useThemesUrlPath,
    useThemesUrlQuery,
} from "../../utils/customHook.util";

export type ThemesQuery = ReturnType<typeof useThemesUrlPath>;

type WithThemeQueryProps = {
    children: (
        pathParams: ParsedThemeUrlState,
        queryParams: ThemeQueryFilters,
    ) => React.JSX.Element;
};

function WithThemeQuery(props: WithThemeQueryProps) {
    const { children } = props;
    const path = useThemesUrlPath();
    const query = useThemesUrlQuery();

    return children(path.urlState, query.urlState);
}

export default WithThemeQuery;
